import { buildDemoStudentsForClass } from "./buildDemoStudents";
import {
  DEMO_TURMA_DISC,
  DEMO_TURMA_DISC_MAT,
  DEMO_TURMA_DISC_CI,
  DEMO_TURMA_DISC_HIST,
  DEMO_TURMA_DISC_HAB
} from "./buildDemoOccurrences";

/**
 * Disciplinas da turma demo (GET .../class/:id/discipline).
 * `teacherAccess: false` — aparece no filtro mas o professor não pode abrir a grade (demo).
 */
export function buildDemoDisciplinesForClass(classId) {
  if (classId !== "DEMO-T1") {
    return [];
  }
  return [
    {
      id: "DEMO-DISC",
      name: "Português — demonstração",
      idTurmaDisc: DEMO_TURMA_DISC,
      mother: false,
      teacherAccess: true
    },
    {
      id: "DEMO-MAT",
      name: "Matemática — sem acesso (demo)",
      idTurmaDisc: DEMO_TURMA_DISC_MAT,
      mother: false,
      teacherAccess: false
    },
    {
      id: "DEMO-CI",
      name: "Ciências — sem acesso (demo)",
      idTurmaDisc: DEMO_TURMA_DISC_CI,
      mother: false,
      teacherAccess: false
    },
    {
      id: "DEMO-HIST",
      name: "História — sem acesso (demo)",
      idTurmaDisc: DEMO_TURMA_DISC_HIST,
      mother: false,
      teacherAccess: false
    },
    {
      id: "DEMO-HAB",
      name: "RELATÓRIO DE HABILIDADES — Educação Infantil",
      idTurmaDisc: DEMO_TURMA_DISC_HAB,
      mother: false,
      teacherAccess: true
    }
  ];
}

/**
 * Provas agrupadas (GET ClassDiaryV1/grades/exams).
 */
export function buildDemoExamsForTurma(idTurmaDisc) {
  if (String(idTurmaDisc) !== String(DEMO_TURMA_DISC)) {
    return [];
  }
  return [
    {
      id: "bim1",
      name: "1º bimestre",
      exams: [
        {
          id: "ET1-P1",
          idStep: "ET1",
          idExam: "P1",
          typeStep: "N",
          name: "Prova 1 — demonstração",
          available: true,
          closed: false,
          allowRelease: true,
          idGroup: 1,
          value: 10,
          average: 5,
          weight: 1,
          weightExam: 1,
          conceptGrades: null
        },
        {
          id: "ET1-P2",
          idStep: "ET1",
          idExam: "P2",
          typeStep: "N",
          name: "Prova 2 — demonstração",
          available: true,
          closed: false,
          allowRelease: true,
          idGroup: 1,
          value: 10,
          average: 5,
          weight: 1,
          weightExam: 1,
          conceptGrades: null
        }
      ]
    }
  ];
}

/**
 * Lista de alunos para lançamento de notas (GET ClassDiaryV1/grades).
 */
export function buildDemoGradesStudents(idTurmaDisc, idStep, idExam) {
  if (String(idTurmaDisc) !== String(DEMO_TURMA_DISC)) {
    return [];
  }
  if (idStep == null || idExam == null) {
    return [];
  }

  const students = buildDemoStudentsForClass("DEMO-T1");
  return students.map((s, i) => ({
    id: s.id,
    rollCallNum: i + 1,
    name: s.name,
    ra: s.ra,
    photo: s.photo
  }));
}
